import { css } from '@emotion/css';
import type { MantineTheme } from '@mantine/core';

export const inputStyles = {
  input: (theme: MantineTheme) => css`
    /* Normal focus state - purple border */
    &:focus {
      border-color: ${theme.colors.purple[5]} !important;
    }

    /* Error state - red border */
    &[data-error] {
      border-color: ${theme.colors.red[5]} !important;
    }

    /* Error + Focus state - red border takes precedence */
    &[data-error]:focus {
      border-color: ${theme.colors.red[5]} !important;
    }
  `,
};

export const themedMantineInput = (theme: MantineTheme) => ({
  input: {
    paddingVertical: theme.spacing.space2,
    borderRadius: 8,
    borderColor: theme.colors.gray[3],
    backgroundColor: theme.colors.gray[0],
    color: theme.colors.gray[7],
  },
});
